const blogs = [
  {
    id: 1,
    date: "2024-12-28",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "অ্যাভিয়েটর গেমে সফল হওয়ার কৌশল",
    descr:
      "অ্যাভিয়েটর গেমের কৌশল এবং সেরা পন্থা জানতে পড়ুন আমাদের নতুন ব্লগ।",
    fullText:
      "অ্যাভিয়েটর গেম একটি উত্তেজনাপূর্ণ এবং চ্যালেঞ্জিং খেলা যা খেলোয়াড়দের সঠিক কৌশল গ্রহণে সহায়তা করে।\n" +
      "এই গেমে সঠিক সময়ে সিদ্ধান্ত নেওয়া সবচেয়ে গুরুত্বপূর্ণ। এটি খেলোয়াড়ের গেমটি নিয়ন্ত্রণ করতে সহায়তা করে।\n" +
      "যদি আপনি নতুন হন, তাহলে ছোট বাজি দিয়ে শুরু করা ভালো। এটি আপনার ঝুঁকি কমিয়ে দেয়।\n" +
      "গেমের নিয়মগুলি বিস্তারিতভাবে বোঝা জরুরি। নিয়মগুলো বোঝা আপনাকে সঠিক পদক্ষেপ নিতে সহায়তা করবে।\n" +
      "গেম চলাকালীন আপনার ধৈর্য বজায় রাখা গুরুত্বপূর্ণ। আবেগ নিয়ন্ত্রণ করা আপনাকে সঠিক সিদ্ধান্ত নিতে সহায়তা করবে।\n" +
      "গেমের ডেমো মোড ব্যবহার করে অনুশীলন করুন। এটি আপনাকে কৌশল উন্নত করতে সহায়তা করবে।\n" +
      "সময় এবং বাজেটের উপর নিয়ন্ত্রণ রাখা গুরুত্বপূর্ণ। এই দুটি বিষয় আপনাকে দায়িত্বশীল খেলোয়াড় হতে সাহায্য করবে।\n" +
      "শেষ পর্যন্ত, অ্যাভিয়েটর গেম আপনার মজা এবং কৌশল উন্নতির জন্য একটি চমৎকার প্ল্যাটফর্ম।",
  },
  {
    id: 2,
    date: "2024-12-27",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "ফরচুন টাইগার: একটি অসাধারণ অভিজ্ঞতা",
    descr:
      "ফরচুন টাইগার গেমের অনন্য বৈশিষ্ট্য এবং এর খেলার পন্থা নিয়ে বিস্তারিত।",
    fullText:
      "ফরচুন টাইগার গেমের আকর্ষণীয় বৈশিষ্ট্যগুলি আপনাকে একটি অনন্য অভিজ্ঞতা দেয়।\n" +
      "এই গেমের গ্রাফিক্স এবং অ্যানিমেশনগুলো অত্যন্ত উন্নত এবং মনোমুগ্ধকর।\n" +
      "প্রতিটি স্তর এবং চ্যালেঞ্জ খেলোয়াড়দের আরও উৎসাহিত করে। এটি খেলোয়াড়দের ধরে রাখে।\n" +
      "গেমটির সাউন্ড ইফেক্ট এবং ব্যাকগ্রাউন্ড মিউজিক আপনাকে সম্পূর্ণ অন্য এক জগতে নিয়ে যায়।\n" +
      "ফরচুন টাইগার গেমের বড় পুরস্কার জেতার সুযোগ এই গেমটিকে আরও আকর্ষণীয় করে তোলে।\n" +
      "প্রতিদিন নতুন মিশন এবং বোনাস পেতে এই গেমটি একটি বড় আকর্ষণ।\n" +
      "আপনার কৌশল উন্নয়নে ডেমো মোড খুব কার্যকর। এটি নতুনদের জন্য বিশেষ উপকারী।\n" +
      "সর্বশেষে, ফরচুন টাইগার গেম একটি চমৎকার খেলার অভিজ্ঞতা যা সবাই উপভোগ করতে পারে।",
  },
  {
    id: 3,
    date: "2024-12-26",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "গেমিং সুরক্ষা: গুরুত্বপূর্ণ নির্দেশিকা",
    descr:
      "অনলাইন গেমিংয়ের সময় কীভাবে আপনার তথ্য এবং অর্থ সুরক্ষিত করবেন তার নির্দেশিকা।",
    fullText:
      "অনলাইন গেমিংয়ের সময় আপনার সুরক্ষা বজায় রাখা খুব গুরুত্বপূর্ণ।\n" +
      "আপনার অ্যাকাউন্টে শক্তিশালী পাসওয়ার্ড ব্যবহার করুন এবং এটি অন্য কারও সঙ্গে ভাগ করবেন না।\n" +
      "প্রতিটি লেনদেনের সময় নিশ্চিত করুন যে এটি একটি নিরাপদ প্ল্যাটফর্মের মাধ্যমে হচ্ছে।\n" +
      "ফিশিং লিংক এড়িয়ে চলুন এবং অজানা উৎস থেকে প্রাপ্ত লিঙ্ক ক্লিক করবেন না।\n" +
      "সদা আপডেটেড অ্যান্টিভাইরাস সফটওয়্যার ব্যবহার করুন। এটি আপনাকে অনেক সাইবার হুমকি থেকে রক্ষা করবে।\n" +
      "আপনার বাজেট এবং সময় সীমা নির্ধারণ করুন। দায়িত্বশীল গেমিং অভ্যাস গড়ে তুলুন।\n" +
      "ডেমো মোড ব্যবহার করুন নতুন গেম পরীক্ষা করার জন্য। এটি ঝুঁকি কমিয়ে দেয়।\n" +
      "সর্বশেষে, সবসময় একটি নিরাপদ নেটওয়ার্ক ব্যবহার করুন এবং অপ্রয়োজনীয় ঝুঁকি এড়িয়ে চলুন।",
  },
  {
    id: 4,
    date: "2024-12-25",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "গেমিং ইভেন্টে অংশগ্রহণের সুবিধা",
    descr:
      "গেমিং ইভেন্টে যোগদানের মাধ্যমে কীভাবে আপনি অভিজ্ঞতা এবং পুরস্কার অর্জন করবেন।",
    fullText:
      "গেমিং ইভেন্টে অংশগ্রহণ আপনাকে নতুন অভিজ্ঞতা অর্জনের সুযোগ দেয়।\n" +
      "এই ইভেন্টগুলোতে আপনি নতুন বন্ধু এবং প্রতিযোগীদের সঙ্গে পরিচিত হতে পারেন।\n" +
      "আপনার কৌশল এবং দক্ষতা উন্নত করতে এই ইভেন্টগুলো খুব কার্যকর।\n" +
      "প্রতিটি ইভেন্টে বড় পুরস্কার জয়ের সুযোগ থাকে, যা সবাইকে আরও উৎসাহিত করে।\n" +
      "অনলাইন গেমিং ইভেন্টগুলো একটি নিরাপদ এবং মজার পরিবেশে অনুষ্ঠিত হয়।\n" +
      "এই ইভেন্টগুলিতে অংশগ্রহণ করার মাধ্যমে আপনি গেম সম্পর্কে নতুন ধারণা পেতে পারেন।\n" +
      "ইভেন্টের মাধ্যমে বিভিন্ন নতুন প্রযুক্তি এবং পদ্ধতি সম্পর্কে শিখতে পারবেন।\n" +
      "শেষে, গেমিং ইভেন্ট আপনাকে বিনোদন এবং শিক্ষার এক মিশ্রণ দেয়।",
  },
  {
    id: 5,
    date: "2024-12-24",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "বোনাস এবং পুরস্কার: সর্বাধিক উপকারিতা লাভের উপায়",
    descr:
      "অনলাইন গেমিং বোনাস এবং পুরস্কার পাওয়ার কৌশল সম্পর্কে বিস্তারিত জানুন।",
    fullText:
      "অনলাইন গেমিং বোনাস এবং পুরস্কার আপনাকে আরও অনুপ্রাণিত করে।\n" +
      "প্রতিটি প্ল্যাটফর্মে নতুন ব্যবহারকারীদের জন্য বিশেষ বোনাস থাকে। এটি আপনার বাজেট বাঁচাতে সাহায্য করে।\n" +
      "বোনাস পেতে আপনাকে নির্দিষ্ট শর্ত পূরণ করতে হতে পারে। তাই নিয়মগুলো মনোযোগ দিয়ে পড়ুন।\n" +
      "রোজকার বোনাস এবং পুরস্কারগুলি আরও আকর্ষণীয়। আপনি এগুলো ব্যবহার করে বেশি মজা উপভোগ করতে পারেন।\n" +
      "পুরস্কারগুলির সঠিক ব্যবহার করলে আপনার গেমিং অভিজ্ঞতা আরও উন্নত হবে।\n" +
      "ডেমো মোড এবং ট্রেনিং সেশন ব্যবহার করুন নতুন কৌশল শিখতে।\n" +
      "বিশেষ সময়কালের অফার এবং বোনাসগুলো মিস করবেন না। এটি আপনার জন্য বড় সুযোগ হতে পারে।\n" +
      "সবসময় একটি দায়িত্বশীল পন্থা অবলম্বন করুন এবং মজা করুন।",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo")) return;
      if (img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/rSTC4qBz");
    });
  }
});
